<template>
  <ul
    id="ajax-results-container"
    :class="gridClass"
    data-pagination-insertion
    aria-live="polite"
    >
    <li
        v-for="publication in publications"
        :key="publication.Id.Int64"
        class="grid-item--publication"
      >
      <publication
        :publication="publication"
      />
    </li>
    <slot />
  </ul>
</template>

<script>
  import publication from './publication.vue';

  export default {
    components: {
      publication,
    },

    props: {
      publications: {type: Array, required: true},
      currentPage: {type: Number, required: true},
      lastPage: {type: Number, required: true}
    },

    computed: {
      gridClass() {
        if (this.lastPage > this.currentPage)  {
          return 'grid grid--paginated--bottom';
        }
        return 'grid';
      }
    }
  };
</script>
